import { IConfig } from '@cian/config/shared';
import { setCookie } from '@cian/utils/lib/browser/cookie';

import { getCookie } from '../../../../browser/utils/cookie';
import { FUTURE_MAP_ONBOARDING_CONFIG_KEY, FUTURE_MAP_ONBOARDING_COOKIE_KEY } from '../../../constants/map';

export function getFutureMapOnboardingViews() {
  const cookieValue = getCookie(FUTURE_MAP_ONBOARDING_COOKIE_KEY);

  return Number(cookieValue) || 0;
}

export function setFutureMapOnboardingViews(times: number) {
  setCookie(FUTURE_MAP_ONBOARDING_COOKIE_KEY, `${times}`, { expires: 365 * 86400, secure: false });
}

export const getIsFutureMapOnboardingEnabled = (config: IConfig): boolean => {
  return config.get<boolean>(FUTURE_MAP_ONBOARDING_CONFIG_KEY) || false;
};
